import CaseStudy, {
  CASE_STUDY_TYPES,
} from "../../../components/case-study/CaseStudy"
import Header from "../../../components/Header"
import Layout from "../../../components/Layout"
import ThumbnailImage from "../../../images/thumbnails/openText-thumbnail.png"

export function Index() {
  return (
    <Layout
      title="Driving 70% higher booth footfall at trade shows | How OpenText cracked the code for higher attendee engagement"
      description=""
      metaImage={ThumbnailImage}
      noIndex
    >
      <Header />
      <div className="h-screen flex items-center justify-center text-2xl">
        Comming soon...
      </div>
      {/* <CaseStudy type={CASE_STUDY_TYPES.OPENTEXT} /> */}
    </Layout>
  )
}

export default Index
